<template>
  <div id="app">
    <Navbar/>
    <router-view/>
    <div class="hidden" id="go-to-top-btn">
      <a href="#home" class="nav-btn"><i class="g3i g3i-carret-top"></i></a>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
export default {
components: {
  Navbar,
},
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  #go-to-top-btn{
    position: fixed;
    z-index: 100;
    bottom: 30px;
    right: 30px;
    //background-color: white;
    border: 2px solid $content-black;
    border-radius: 50%;
    transition: all 0.2s, right 0.4s;
    opacity: .6;
    @include mq768{
      bottom: 10px;
      right: 10px;
    }
    &.hidden{
      right: -65px;
    }
    a{
      padding: 10px;
      display: block;
    }
    .g3i{
      color: $content-black;
      transition: 0.2s;
    }
    &:hover{
      background-color: $main-color;
      border: 2px solid $main-color;
      .g3i{
        color: white;
      }
    }
  }
}
</style>
